module.exports = __webpack_public_path__ + "media/src/images/proctored_icons/no_internet_browsing-8b25b39b8aa384b1a13d0a83d6f616eb.svg";